<template>
  <div class="card">
    <div class="title">{{ title }}</div>
    <p class="desc">{{ desc }}</p>
    <button
        :class="{isActive}"
        :disabled="disabled"
        @click="$emit('chose')">Выбрать</button>
  </div>
</template>

<script>
export default {
  name: "Rent_Chose_Role",
  props: {
    title: String,
    desc: String,
    isActive: Boolean,
    disabled: Boolean
  }
}
</script>

<style scoped lang="scss">
.card {
  background-color: #FAFAFA;
  border: 1px solid #DBBFA7;
  border-radius: 10px;
  padding: 15px 20px 20px 20px;
  height: 320px;
  position: relative;
}

.title {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
  margin-bottom: 10px;
}

.desc {
  font-size: 12px;
  line-height: 1.67;
  color: #383838;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  width: calc(100% - 40px);
  height: 50px;

  border: 2px solid #DBBFA7;
  border-radius: 5px;

  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: #383838;

  background-color: #fff;

  font-family: "Open Sans", sans-serif;
  &.isActive {
    background-color: #DBBFA7;
    color: #ffffff;
  }
}
</style>
